import { React, useEffect } from "react";
import {
  Container,
  Grid,
  GridColumn,
  GridRow,
  Header,
  Image,
} from "semantic-ui-react";

export default function AboutUs() {
  useEffect(() => {
    document.title = "About Custom Metal Tas | Metal Fabrication Experts in Launceston";
    document.querySelector('meta[name="description"]').setAttribute(
      "content",
      "Learn about Custom Metal Tas, Launceston's leading metal fabrication experts. Discover our origin, mission, and commitment to quality metalwork and custom solutions."
    );
  }, []);

  const h1Style = {
    fontFamily: "'B612', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    fontSize: "clamp(3em, 4vw, 4em)",
  };

  const h2Style = {
    ...h1Style,
    fontSize: "clamp(2.7em, 3.5vw, 3.7em)",
    padding: "0em 0em 0.5em 0em",
  };

  const pStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    fontSize: "clamp(1.1em, 1vw, 1.4em)",
    lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  };

  return (
    <main>
      {/* Header Section */}
      <section aria-labelledby="about-heading">
        <Grid>
          <GridRow
            role="banner"
            style={{
              position: "relative",
              width: "100vw",
              overflow: "hidden",
              margin: "-7em 0em 0em 0em",
              height: "20em",
              backgroundImage: "url('./aboutUsHeader.webp')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              textAlign: "center",
            }}
          >
            <GridColumn
              verticalAlign="bottom"
              style={{
                padding: "0em 0em 3em 5em",
                maxWidth: "100em",
                textAlign: "left",
              }}
            >
              <Header as="h1" id="about-heading" style={h1Style}>
                About Us
              </Header>
            </GridColumn>
          </GridRow>
        </Grid>
      </section>

      {/* Origin Story Section */}
      <section aria-labelledby="origin-story-heading">
        <Grid stackable style={{ padding: "10em 5% 10em 5%" }}>
          <GridRow>
            <GridColumn
              verticalAlign="middle"
              textAlign="left"
              width={10}
              style={{ padding: "0em 5em 0em 0em" }}
            >
              <Container>
                <Header as="h2" id="origin-story-heading" style={h2Style}>
                  Origin Story
                </Header>
              </Container>
              <Container style={pStyle}>
                Custom Metal was founded in April 2023 with a vision to provide
                high-quality metal fabrication services backed by years of industry
                experience. With over seven years of hands-on expertise in metalwork,
                our team has worked on a diverse range of projects, from structural
                steel to precision welding. Our advanced training—including Certificate
                III in Metal Fabrication and Certificate IV in Engineering Welding—has
                deepened our understanding of metallurgy, allowing us to tailor
                solutions for any project. What started as a passion for craftsmanship
                has now grown into a trusted name in metal fabrication, delivering
                custom solutions across Tasmania.
              </Container>
            </GridColumn>
            <GridColumn width={6}>
              <Image
                src="./metalWorkFurnace.webp"
                alt="Metal being heated in a furnace by a skilled metalworker"
                fluid
                loading="lazy"
              />
            </GridColumn>
          </GridRow>
        </Grid>
      </section>

      {/* Decorative Elements */}
      <div role="presentation">
        <Image src="./topBreak.svg" alt="" aria-hidden="true" />
        <Image src="./bottomBreak.svg" alt="" aria-hidden="true" />
      </div>

      {/* Our Mission Section */}
      <section aria-labelledby="mission-heading">
        <Grid stackable style={{ padding: "10em 5% 10em 5%" }}>
          <GridRow>
            <GridColumn
              verticalAlign="middle"
              textAlign="left"
              width={10}
              style={{ padding: "0em 5em 0em 0em" }}
            >
              <Container>
                <Header as="h2" id="mission-heading" style={h2Style}>
                  Our Mission
                </Header>
              </Container>
              <Container style={pStyle}>
                At Custom Metal, our mission is to deliver high-quality, custom metal
                fabrication with precision and reliability. We are committed to
                providing tailored solutions that meet our clients’ needs, ensuring
                every project is built to last. Using cutting-edge techniques and
                premium materials, we strive to exceed expectations while delivering
                outstanding customer service. From fabrication to repairs, we take
                pride in our work and focus on delivering excellence—on time, every
                time.
              </Container>
            </GridColumn>
            <GridColumn width={6}>
              <Image
                src="./polishingMetalBar.webp"
                alt="Metal bar being polished by a skilled metalworker"
                fluid
                loading="lazy"
              />
            </GridColumn>
          </GridRow>
        </Grid>
      </section>

      {/* Decorative Elements */}
      <div role="presentation">
        <Image src="./topBreak.svg" alt="" aria-hidden="true" />
      </div>
    </main>
  );
}
